import { render, staticRenderFns } from "./DetailRow.vue?vue&type=template&id=3c6ecce4&scoped=true&"
import script from "./DetailRow.vue?vue&type=script&lang=js&"
export * from "./DetailRow.vue?vue&type=script&lang=js&"
import style0 from "./DetailRow.vue?vue&type=style&index=0&id=3c6ecce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ecce4",
  null
  
)

export default component.exports